var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-nowrap align-center",class:_vm.item.color},[_c('v-icon',{class:_vm.item.color},[_vm._v("brightness_1")]),_c('span',{staticClass:"pl-2 text-truncate"},[_vm._v(_vm._s(_vm.item.label))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }